import React from "react"
import BoundedInput from "../../../InputForm/BoundedForm"

class ExpenseFormComponent extends React.Component {

	render() {
    const ids          = {
			name        : "ppi-expense-name",
		}

		return (
			<form onSubmit={this.props.onSubmit}>
				{ this.props.delete
					? <div>Êtes-vous sûr de vouloir supprimer la dépense <strong>{this.props.expense.name}</strong> ?</div>
					: <div className="columns is-desktop">
							<div className="column">
								<div className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.name}>Nom de la dépense</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<BoundedInput
													className   = "input"
													id          = {ids.name}
													name        = "name"
													min="0"
													max="30"
													recommendedMax="30"
													onChange    = {this.props.onNameChange}
													placeholder = "Nom de la dépense"
													type        = "text"
													value       = {this.props.name}
													required />
											</span>
										</span>
									</span>
								</div>
							</div>
						</div>
				}
				<div className="columns">
					{/* !this.props.submitting
						? <div className="column">
								<button className={`button is-secondary ${this.props.submitting ? "is-loading" : ""}`}>
									Annuler
								</button>
							</div>
						: null
					*/}
					<div className="column">
						<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}>
							{this.props.delete ? "Supprimer" : (this.props.expense ? "Modifier" : "Ajouter")} la dépense
						</button>
					</div>
				</div>
			</form>
		)
	}

}

export default ExpenseFormComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/expenses/form-component.js